// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCard\ApiTopicCard.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { BerthAmenityType, BerthAmenityTypeData, BerthAmenityTypeOptions } from 'data/models/BerthAmenityType';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { TopicCardAvailableAttachment, TopicCardAvailableAttachmentData, TopicCardAvailableAttachmentOptions } from 'data/models/TopicCardAvailableAttachment';
import { TopicCardChange, TopicCardChangeData, TopicCardChangeOptions } from 'data/models/TopicCardChange';
import { TopicCardOption, TopicCardOptionData, TopicCardOptionOptions } from 'data/models/TopicCardOption';
import { TopicCardSelectedOption, TopicCardSelectedOptionData, TopicCardSelectedOptionOptions } from 'data/models/TopicCardSelectedOption';
import { TopicCardTemplate, TopicCardTemplateData, TopicCardTemplateOptions } from 'data/models/TopicCardTemplate';
import { TopicCardTimeEntry, TopicCardTimeEntryData, TopicCardTimeEntryOptions } from 'data/models/TopicCardTimeEntry';
import { TopicCardUserAssignment, TopicCardUserAssignmentData, TopicCardUserAssignmentOptions } from 'data/models/TopicCardUserAssignment';
import { TopicCardQuestionType } from 'server/enums/TopicCardQuestionType';
import { TopicCardStatus } from 'server/enums/TopicCardStatus';

// TopicCardData is the class that TopicCard serializes to/from
export interface TopicCardData {
    Id : number;
    Url : string | null;
	
    AmenityType : BerthAmenityTypeData | null;
    AmenityTypeId : number | null;
    AnsweredBy : PCUserData | null;
    AnsweredById : number | null;
    AvailableAttachments : TopicCardAvailableAttachmentData[] | null;
    Berth : BerthData | null;
    BerthId : number | null;
    Changes : TopicCardChangeData[] | null;
    Comments : CommentData[] | null;
    CommentsUrl : string | null;
    Options : TopicCardOptionData[] | null;
    People : TopicCardUserAssignmentData[] | null;
    PortCall : PortCallData | null;
    PortCallId : number;
    SelectedOption : TopicCardSelectedOptionData | null;
    Template : TopicCardTemplateData | null;
    TemplateId : number;
	
    ConfirmedDate : /* ISO8601 */ string | null;
    DeniedDate : /* ISO8601 */ string | null;
    Guid : /* GUID */ string;
    IsYes : boolean;
    LastAnswer : /* ISO8601 */ string;
    Question : string;
    QuestionType : TopicCardQuestionType;
    Remarks : string | null;
    Status : TopicCardStatus;
    TimeEntry : TopicCardTimeEntryData;
    Title : string;
}

// TopicCardOptions is the class which may be passed to the TopicCard constructor to define optional initial data values
export interface TopicCardOptions {
    Id : number;
    Url? : string | null;
	
    AmenityType? : BerthAmenityTypeOptions | null;
    AmenityTypeId? : number | null;
    AnsweredBy? : PCUserOptions | null;
    AnsweredById? : number | null;
    AvailableAttachments? : TopicCardAvailableAttachmentOptions[] | null;
    Berth? : BerthOptions | null;
    BerthId? : number | null;
    Changes? : TopicCardChangeOptions[] | null;
    Comments? : CommentOptions[] | null;
    CommentsUrl? : string | null;
    Options? : TopicCardOptionOptions[] | null;
    People? : TopicCardUserAssignmentOptions[] | null;
    PortCall? : PortCallOptions | null;
    PortCallId? : number;
    SelectedOption? : TopicCardSelectedOptionOptions | null;
    Template? : TopicCardTemplateOptions | null;
    TemplateId? : number;
	
    ConfirmedDate? : /* ISO8601 */ string | null;
    DeniedDate? : /* ISO8601 */ string | null;
    Guid? : /* GUID */ string;
    IsYes? : boolean;
    LastAnswer? : /* ISO8601 */ string;
    Question? : string;
    QuestionType? : TopicCardQuestionType;
    Remarks? : string | null;
    TimeEntry? : TopicCardTimeEntryOptions;
    Title? : string;
}

export class TopicCard {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public AmenityType : DataSignal<BerthAmenityType | null>;
    public AmenityTypeId : DataSignal<number | null>;
    public AnsweredBy : DataSignal<PCUser | null>;
    public AnsweredById : DataSignal<number | null>;
    public AvailableAttachments : SDataArray<TopicCardAvailableAttachment>;
    public Berth : DataSignal<Berth | null>;
    public BerthId : DataSignal<number | null>;
    public Changes : SDataArray<TopicCardChange>;
    public Comments : SDataArray<Comment>;
    public CommentsUrl : DataSignal<string | null>;
    public Options : SDataArray<TopicCardOption>;
    public People : SDataArray<TopicCardUserAssignment>;
    public PortCall : DataSignal<PortCall | null>;
    public PortCallId : DataSignal<number>;
    public SelectedOption : DataSignal<TopicCardSelectedOption | null>;
    public Template : DataSignal<TopicCardTemplate | null>;
    public TemplateId : DataSignal<number>;
	
    public ConfirmedDate : DataSignal<TZDate | null>;
    public DeniedDate : DataSignal<TZDate | null>;
    public Guid : DataSignal<string>;
    public IsYes : DataSignal<boolean>;
    public LastAnswer : DataSignal<TZDate>;
    public Question : DataSignal<string>;
    public QuestionType : DataSignal<TopicCardQuestionType>;
    public Remarks : DataSignal<string | null>;
    public TimeEntry : TopicCardTimeEntry;
    public Title : DataSignal<string>;

    constructor();
    constructor(data : TopicCardOptions);
    constructor(data: TopicCardOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.AmenityType = S.value<BerthAmenityType | null>(null);
        this.AmenityTypeId = jsonableObservable(S.value<number | null>(data && data.AmenityTypeId !== undefined ? data.AmenityTypeId : null));
        this.AnsweredBy = S.value<PCUser | null>(null);
        this.AnsweredById = jsonableObservable(S.value<number | null>(data && data.AnsweredById !== undefined ? data.AnsweredById : null));
        this.AvailableAttachments = SArray<TopicCardAvailableAttachment>([]);
        this.Berth = S.value<Berth | null>(null);
        this.BerthId = jsonableObservable(S.value<number | null>(data && data.BerthId !== undefined ? data.BerthId : null));
        this.Changes = SArray<TopicCardChange>([]);
        this.Comments = SArray<Comment>([]);
        this.CommentsUrl = jsonableObservable(S.value<string | null>(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.Options = SArray<TopicCardOption>([]);
        this.People = SArray<TopicCardUserAssignment>([]);
        this.PortCall = S.value<PortCall | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.SelectedOption = S.value<TopicCardSelectedOption | null>(null);
        this.Template = S.value<TopicCardTemplate | null>(null);
        this.TemplateId = jsonableObservable(S.value<number>(data && data.TemplateId !== undefined ? data.TemplateId : 0));
	    
        this.ConfirmedDate = jsonableObservable(S.value<TZDate | null>(data && data.ConfirmedDate !== undefined ? data.ConfirmedDate === null ? null : new TZDate(data.ConfirmedDate) : null, TZDate.nullableEq));
        this.DeniedDate = jsonableObservable(S.value<TZDate | null>(data && data.DeniedDate !== undefined ? data.DeniedDate === null ? null : new TZDate(data.DeniedDate) : null, TZDate.nullableEq));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IsYes = jsonableObservable(S.value<boolean>(data && data.IsYes !== undefined ? data.IsYes : false));
        this.LastAnswer = jsonableObservable(S.value<TZDate>(data && data.LastAnswer !== undefined ? new TZDate(data.LastAnswer) : new TZDate(0), TZDate.eq));
        this.Question = jsonableObservable(S.value<string>(data && data.Question !== undefined ? data.Question : ''));
        this.QuestionType = jsonableObservable(S.value<TopicCardQuestionType>(data && data.QuestionType !== undefined ? data.QuestionType : 0));
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
        this.TimeEntry = data && data.TimeEntry !== undefined ? new TopicCardTimeEntry(data.TimeEntry) : new TopicCardTimeEntry();
        this.Title = jsonableObservable(S.value<string>(data && data.Title !== undefined ? data.Title : ''));
    }

    static key(obj : TopicCard) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardOptions) {
        return obj.Id;
    }

    static update(obj : TopicCard, data : TopicCardOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.AmenityTypeId !== undefined) obj.AmenityTypeId(data.AmenityTypeId);
            if (data.AnsweredById !== undefined) obj.AnsweredById(data.AnsweredById);
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
            if (data.CommentsUrl !== undefined) obj.CommentsUrl(data.CommentsUrl);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.TemplateId !== undefined) obj.TemplateId(data.TemplateId);
	        
            if (data.ConfirmedDate !== undefined) obj.ConfirmedDate(data.ConfirmedDate === null ? null : new TZDate(data.ConfirmedDate));
            if (data.DeniedDate !== undefined) obj.DeniedDate(data.DeniedDate === null ? null : new TZDate(data.DeniedDate));
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.IsYes !== undefined) obj.IsYes(data.IsYes);
            if (data.LastAnswer !== undefined) obj.LastAnswer(new TZDate(data.LastAnswer));
            if (data.Question !== undefined) obj.Question(data.Question);
            if (data.QuestionType !== undefined) obj.QuestionType(data.QuestionType);
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
            if (data.TimeEntry !== undefined) TopicCardTimeEntry.update(obj.TimeEntry, data.TimeEntry);
            if (data.Title !== undefined) obj.Title(data.Title);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCard.ts